import type { ICommandData } from '@tencent/slide-sdk-pb-model';
import type { MutationSource } from '../constants';

export interface IFollowUserChange {
    taskId: number;
    revision: number;
    command: ICommandData;
    source: MutationSource;
    combineTaskId?: number;
    canCombine?: boolean;
}

export class CombineUserChange {
    static maxSize = 1024 * 1024; // 1M（后台理论上支持20M）
    private userChanges: IFollowUserChange[] = [];
    private id = -1;
    private currentSize = 0;

    public getRevision() {
        return this.userChanges[0].revision;
    }

    public getSize() {
        return this.currentSize;
    }

    public add(userChanges: IFollowUserChange[]) {
        const canNotCombineIndex = userChanges.findIndex((userChange) => !userChange.canCombine);
        const validUserChanges = canNotCombineIndex > 0 ? userChanges.slice(0, canNotCombineIndex) : userChanges;
        this.userChanges.push(validUserChanges[0]);
        validUserChanges.slice(1).find((userChange) => {
            const size = this.getUserChangeSize(JSON.stringify(userChange));
            if (this.currentSize + size > CombineUserChange.maxSize) {
                return true;
            }
            this.userChanges.push(userChange);
            this.currentSize += size;
            return false;
        });
    }

    public setTaskId(taskId: number) {
        this.id = taskId;
        this.userChanges.forEach((userChange) => (userChange.combineTaskId = taskId));
    }

    public getTaskId() {
        return this.id;
    }

    public getRawTaskId() {
        return this.userChanges.map((userChange) => userChange.taskId);
    }

    public getRawUserChanges() {
        return this.userChanges;
    }

    private getUserChangeSize(data: string) {
        const chunkSize = 1024;
        let offset = 0;
        let totalBytes = 0;

        while (offset < data.length) {
            const chunk = data.slice(offset, offset + chunkSize);
            const encoder = new TextEncoder();
            const bytes = encoder.encode(chunk);
            totalBytes += bytes.length;
            offset += chunkSize;
        }
        return totalBytes;
    }
}
